<!--Good details-->
@if (stowage.good; as good) {
  <div class="row">
    <div class="declaration-block col-12">
      <h2>Good details</h2>
    </div>
    <div class="col-md-6">
      <app-form-group>
        <label>Name</label>
        <textarea class="form-control"
        readonly>{{ stowage.type === 'container' ? refData.containerGoodDataFormatterFull(good.goodData) : refData.goodDataFormatter(good.goodData) }}</textarea>
      </app-form-group>
      @if (good.type === 'chemical' || good.type === 'gas' || good.type === 'oil' || good.type === 'containerGood') {
        <app-form-group>
          <label>Flashpoint (&deg;C)</label>
          <input [(ngModel)]="good.flashPoint" appDecimalNumber class="form-control">
        </app-form-group>
      }
      @if (good.type === 'containerGood') {
        <app-form-group>
          <label>Segregation Information</label>
          <input [(ngModel)]="good.segregationInformation" type="text" maxlength="350" class="form-control">
        </app-form-group>
      }
      @if (good.type === 'chemical') {
        <div>
          @if (good.goodData.specOpRequirements?.indexOf('16.2.9') >= 0) {
            <app-form-group>
              <label>Melting point (&deg;C)</label>
              <input [(ngModel)]="good.meltingPoint" appDecimalNumber class="form-control">
            </app-form-group>
          }
          @if (good.goodData.specOpRequirements?.indexOf('16.2.9') >= 0 || good.goodData.specOpRequirements?.indexOf('16.2.6') >= 0) {
            <app-form-group>
              <label>Heating order (&deg;C)</label>
              <input [(ngModel)]="good.heatingOrder" appDecimalNumber maxlength="100" class="form-control">
            </app-form-group>
          }
        </div>
      }
    </div>
    <div class="col-md-6">
      @if (good.type === 'chemical') {
        <div>
          @if (good.goodData.specOpRequirements?.indexOf('16.2.6') >= 0) {
            <app-form-group>
              <label>Viscosity (mPa/s at 20&deg;C)</label>
              <input [(ngModel)]="good.viscosity" appDecimalNumber class="form-control">
            </app-form-group>
          }
          @if (good.viscosity > 50) {
            <app-form-group>
              <label>Critical temperature (&deg;C)</label>
              <input [(ngModel)]="good.criticalTemperature" appDecimalNumber maxlength="100" class="form-control"
                required>
            </app-form-group>
          }
        </div>
      }
      <app-form-group>
        <label>Remarks</label>
        <textarea [(ngModel)]="good.remarks" type="text" maxlength="350" class="form-control"></textarea>
      </app-form-group>
      @if (good && good.goodData && good.goodData.goodCode === '500029') {
        <div>
          <app-form-group>
            <label>Crude oil washing</label>
            <app-yes-no required [(ngModel)]="$any(good).crudeOilWashing"></app-yes-no>
          </app-form-group>
        </div>
      }
    </div>
  </div>
}

<!-- radioactivity -->
@if ((stowage.good && stowage.good['radioactive'] && stowage.good['radioactivity']); as material) {
  <div class="row">
    <div class="declaration-block col-12">
      <h2>Radioactivity details</h2>
    </div>
    <div class="col-md-6">
      <app-form-group>
        <label>Radionuclide</label>
        <app-search [(ngModel)]="material.radionuclide" [searchFunction]="refData.findRadionuclide"
        dataKey="name" required placeholder="Find radionuclide"></app-search>
      </app-form-group>
      <app-form-group>
        <label>Package category</label>
        <app-select [(ngModel)]="material.packageCategory" [options]="refData.packageCategories"
        [formatter]="refData.packageCategoryFormatter"></app-select>
      </app-form-group>
      <app-form-group>
        <label>Identification</label>
        <input [(ngModel)]="material.identification" class="form-control">
      </app-form-group>
      <app-form-group>
        <label>Level (Bq)</label>
        <input [(ngModel)]="material.level" appDecimalNumber [maxDecimals]="0" [min]="1" title="Must be positive (>0)"
        class="form-control">
      </app-form-group>
    </div>
    <div class="col-md-6">
      <app-form-group>
        <label>Transport index</label>
        <app-select [(ngModel)]="material.transportIndex" [options]="refData.transportIndexes"
        [formatter]="refData.transportIndexFormatter"></app-select>
      </app-form-group>
      <app-form-group>
        <label>Critical safety index</label>
        <input [(ngModel)]="material.criticalSafetyIndex" appDecimalNumber [maxDecimals]="2" class="form-control">
      </app-form-group>
      <app-form-group>
        <label>License number</label>
        <input [(ngModel)]="material.licenseNumber" class="form-control">
      </app-form-group>
      <app-form-group>
        <label>Remarks</label>
        <textarea [(ngModel)]="material.remarks" type="text" maxlength="100" class="form-control"></textarea>
      </app-form-group>
    </div>
  </div>
}

<!-- Container item details -->
@if (stowage.type === 'container' || stowage.type === 'breakBulk') {
  <div class="row">
    <div class="declaration-block col-12">
      <h2>Stowage details</h2>
    </div>
    <div class="col-md">
      @if (!$any(stowage).trailer && stowage.type !== 'breakBulk' && !isContainerItem) {
        <app-form-group>
          <label>Unclean tank container</label>
          <app-yes-no [(ngModel)]="stowage.uncleanTankContainer" (ngModelChange)="toggleOption(stowage)"
          required></app-yes-no>
        </app-form-group>
      }
      @if (!$any(stowage).uncleanTankContainer) {
        <app-form-group>
          <label>Number of outer packages</label>
          <input [(ngModel)]="stowage.numberOfOuterPackages" appDecimalNumber [maxDecimals]="0" [min]="1"
            class="form-control" [required]="!$any(stowage).uncleanTankContainer">
        </app-form-group>
        <app-form-group>
          <label>Outer package type</label>
          <app-select [(ngModel)]="stowage.outerPackageType" dataKey="code"
            [optionsProvider]="$any(refData.getPackageTypes)"
          [formatter]="refData.packageTypeFormatter"></app-select>
        </app-form-group>
        <app-form-group>
          <label>Number of inner packages</label>
          <input [(ngModel)]="stowage.numberOfInnerPackages" appDecimalNumber [maxDecimals]="0" [min]="1"
            class="form-control">
        </app-form-group>
        @if (stowage.numberOfInnerPackages > 0) {
          <app-form-group>
            <label>Inner package type</label>
            <app-select [(ngModel)]="stowage.innerPackageType" dataKey="code"
              [optionsProvider]="$any(refData.getPackageTypes)"
            [formatter]="refData.packageTypeFormatter"></app-select>
          </app-form-group>
        }
      }
    </div>
    <div class="col-md">
      @if (!$any(stowage).uncleanTankContainer) {
        <app-form-group>
          <label>Net weight (kg)</label>
          <input [(ngModel)]="stowage.netWeight" appDecimalNumber [maxDecimals]="3" class="form-control">
        </app-form-group>
        <app-form-group>
          <label>Net Explosive Mass (kg)</label>
          <input [(ngModel)]="stowage.netExplosiveMass" appDecimalNumber maxlength="10" class="form-control">
        </app-form-group>
        <app-form-group>
          <label>Transport in limited quantity</label>
          <app-yes-no [(ngModel)]="stowage.transportInLimitedQuantity" required></app-yes-no>
        </app-form-group>
      }
    </div>
  </div>
}

<!-- fumigation -->
@if (stowage.type === 'hold' && (isRotterdam || isAmsterdam)) {
  <div class="row">
    <div class="declaration-block col-12">
      <h2>Fumigation details</h2>
    </div>
    <div class="col-md-6">
      <app-form-group>
        <label>Cargo fumigated</label>
        <app-yes-no [disabled]="hasNoBerthVisits()"
                    [(ngModel)]="stowage.fumigated"
                    (ngModelChange)="stowage.fumigation = stowage.fumigated ? {} : null" required>
        </app-yes-no>
      </app-form-group>
    </div>
    <div class="col-md-6">
    </div>
    @if (stowage.fumigated) {
      <div class="col-md-6">
        <app-form-group>
          <label for="fumigationDate">Date of fumigation</label>
          <app-date-field id="fumigationDate" [(ngModel)]="stowage.fumigation.fumigationTimestamp" [dateOnly]="true" required></app-date-field>
        </app-form-group>
      </div>
      <div class="col-md-6">
        <app-form-group>
          <label>Place of fumigation</label>
          <app-search [(ngModel)]="stowage.fumigation.locationOfFumigation"
                      [inputFormatter]="refData.locationFormatter"
                      [searchFunction]="refData.findLocation"
                      [resultFormatter]="refData.locationFormatter"
                      required>
          </app-search>
        </app-form-group>
      </div>

      <div class="declaration-block col-12">
        <hr style="margin: 0.1em"/>
        <br>
      </div>

      <app-fumigation-details
        [fumigation]="stowage.fumigation">
      </app-fumigation-details>
    }
  </div>
}
<!--<pre>{{stowage | json}}</pre>-->
